<template>
    <div class="container-fluid bg-login">
      <div class="bg-banner">
        <div style="position: absolute; top: 20px; left: 20px">
          <LanguageIcons />
        </div>
        <div class="login" style="padding-top: 25vh;">
          <div class="loginblock">
            <div class="head">
              <h1> {{ $t('login.header') | capitalize }} </h1>
            </div>
            <div class="content">
              <form id="form-login">
                <div class="fields">
                  <div class="field">
                    <input name="email"
                           :placeholder="$t('login.email') | capitalize"
                           v-model="email"
                           id="email"
                           type="email"
                           autocomplete="on">
                  </div>
                  <div class="field">
                    <input name="password"
                           autocomplete="off"
                           v-on:keyup.enter="postLogin"
                           :placeholder="$t('login.password') | capitalize"
                           type="password" v-model="password"
                           id="password">
                  </div>
                  <div v-if="invalidLogin" class="login-alert">
                    {{ $t('login.invalid_login') }}
                  </div>
                  <div v-else-if="sessionExpired" class="login-alert">
                    {{ $t('login.session_expired') }}
                  </div>
                  <div v-else class="login-alert">
                    &nbsp;
                  </div>
                  <div class="field buttonfield">
                    <a :class="{'button': true, 'disabled': loading}" @click="postLogin">
                      {{ $t('login.header') | capitalize }}
                      <span v-if="!loading" class="icon icon-arrow-long-right"></span>
                      <Loading v-else visible="visible" />
                    </a>
                  </div>
                </div>
              </form>

              <div class="password-reset">
                <a class="text" @click="loginDemo()">{{ $t('login.demo_account') }}</a>
                <br><br>
                <a class="text" @click="toPasswordForgot()">{{ $t('login.forgot_password') }}</a>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
</template>

<script>
import Auth from '@/api/auth';
import axios from '@/plugins/axios';
import User from '@/api/user';
import config from '@/util/config';
import LanguageIcons from '@/components/Layout/LanguageIcons.vue';
import Loading from '@/components/Loading.vue';

export default {
  name: 'login',
  components: { Loading, LanguageIcons },
  watch: {
    loggedIn() {
      User.getMe()
        .then((response) => {
          this.user = response.data;
        });
    },
    user() {
      User.getTenants(this.user.id)
        .then((response) => {
          this.tenants = response.data;
        });
    },
  },
  data() {
    return {
      email: '',
      password: '',
      loading: false,
      user: [],
      tenants: [],
      loggedIn: false,
      invalidLogin: false,
      selected_tenant: null,
      selected_network: null,
      networks_disabled: true,
      networks_loading: false,
      networks: [],
      sessionExpired: false,
    };
  },
  created() {
    this.sessionExpired = this.$route.query.reason === 'session-expired';

    if (this.sessionExpired) {
      this.$router.replace({ name: 'login' });
    }
  },
  methods: {
    resetStoredData() {
      localStorage.removeItem('tenant_id');
      localStorage.removeItem('network_id');
      axios.defaults.headers['x-tenant'] = null;
      axios.defaults.headers['x-network'] = null;
    },
    loginDemo() {
      this.resetStoredData();
      this.loading = true;
      this.invalidLogin = false;
      this.sessionExpired = false;
      Auth.login(config.demoEmail, config.demoPassword)
        .then((response) => {
          axios.defaults.headers.Authorization = `Bearer ${response.access_token}`;
          this.$store.dispatch('auth/setToken', {
            token: response.access_token,
          });
          this.$router.push({ name: 'switcher' });
        })
        .catch(() => {
          this.loading = false;
          this.invalidLogin = true;
        });
    },
    postLogin() {
      if (this.loading) {
        return;
      }
      this.resetStoredData();
      this.loading = true;
      this.invalidLogin = false;
      this.sessionExpired = false;
      Auth.login(this.email, this.password)
        .then((response) => {
          axios.defaults.headers.Authorization = `Bearer ${response.access_token}`;
          this.$store.dispatch('auth/setToken', {
            token: response.access_token,
          });
          this.$router.push({ name: 'switcher', params: { fromLogin: true } });
        })
        .catch(() => {
          this.loading = false;
          this.invalidLogin = true;
        });
    },
    toPasswordForgot() {
      this.$router.push({ name: 'password.forgot' });
    },
  },
  beforeMount() {
    this.$emit('showFullscreen', true);
  },
};
</script>

<style>

.bg-login {
  background-image: url('../../assets/img/bg.png');
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
}

.login-alert {
  font-style: italic;
  font-size: 14px;
}

.bg-banner {
  background: url('../../assets/img/banner.svg') no-repeat;
  background-size: 100% auto;
}
.password-reset a.text {
  text-decoration: underline;
}
.password-reset a.text:hover {
  text-decoration: none;
}
</style>
